import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { Type } from '@nerdwallet/currency';
import {
  MortgageRateTagline,
  RateSummaryTable,
  MortgageRateInsight,
} from '@nerdwallet/mortgage-rates-trend/components';

import style from './rates-trend.module.less';

function validateRates(rateSummary) {
  return (
    _.get(rateSummary, 'today.fixed_30') &&
    _.get(rateSummary, 'today.fixed_15') &&
    _.get(rateSummary, 'today.arm_5_1')
  );
}

const RateTrends = ({ rateSummary, stateName }) => {
  if (!validateRates(rateSummary)) {
    return null;
  }

  return (
    <div className={style.container}>
      <Type size={3} component="h3" bold>
        {stateName} mortgage and refinance rates today (APR)
      </Type>
      <RateSummaryTable
        rateSummary={rateSummary}
        className={style.rateSummary}
      />
      <MortgageRateInsight
        rateSummary={rateSummary}
        state={stateName}
        title="Today's rate"
        className={style.insight}
      >
        <MortgageRateTagline
          rate={_.get(rateSummary, 'today.fixed_30')}
          rateDescription="30-year fixed"
        />
      </MortgageRateInsight>
      <div className={style.clear} />
    </div>
  );
};

RateTrends.propTypes = {
  stateName: PropTypes.string.isRequired,
  rateSummary: PropTypes.shape({
    today: PropTypes.shape({
      fixed_30: PropTypes.number,
      fixed_15: PropTypes.number,
      arm_5_1: PropTypes.number,
    }),
  }),
};

RateTrends.defaultProps = {
  rateSummary: {},
};

export default RateTrends;
